import { REQUEST } from '@/constants/api';

import {
  AddDocumentRequest,
  AddSigningDocumentRequest,
} from '@/types/api/document';
import {
  ConfirmSecondIdPayloadFormType,
  DocumentType,
  SigningDocument,
} from '@/types/document';

import { buildRequestParams } from '@/utils/api';

import { axios } from './axios';

export const addDocument = async ({
  operationId,
  ...payload
}: AddDocumentRequest) => {
  const formData = new FormData();
  formData.append('file', payload.file);
  formData.append('type', payload.section);
  formData.append('docType', payload.type || '');

  if (payload.clientId !== undefined) {
    formData.append('clientId', String(payload.clientId));
  }

  const result = await axios.post<{
    message: string;
    docType?: DocumentType;
  }>(
    `${REQUEST.DOCUMENT.ROOT}${buildRequestParams({ operationId })}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return result.data;
};

export const getLocalDocumentUrlFromS3 = async (uri: string) => {
  const result = await axios.get(REQUEST.DOCUMENT.DOWNLOAD_BY_S3, {
    params: {
      uri,
    },
    responseType: 'blob',
  });

  return URL.createObjectURL(result.data);
};

export const getSigningDocuments = async () => {
  const result = await axios.get<SigningDocument[]>(REQUEST.SIGNING_DOCUMENTS);

  return result.data;
};

export const addSigningDocument = async ({
  ...payload
}: AddSigningDocumentRequest) => {
  const result = await axios.post(REQUEST.ADD_SIGN_DOCUMENT, payload);
  return result.data;
};

export const getDocumentBlobUrl = async (docUrl: string) => {
  const result = await axios.get(docUrl, {
    responseType: 'blob',
  });

  return URL.createObjectURL(result.data);
};

export const confirmSecondIdInfo = async (
  documentId: number | string,
  payload: ConfirmSecondIdPayloadFormType,
) => {
  const result = await axios.post<{
    message: string;
  }>(`${REQUEST.DOCUMENT.CONFIRM_INFO}/${documentId}`, payload);
  return result.data;
};
